import {
  IconArrowMerge,
  IconArrowsSplit,
  IconAutomation,
  IconBrandZapier,
  IconBriefcase,
  IconBuilding,
  IconCalendarEvent,
  IconCompass,
  IconCopy,
  IconDatabase,
  IconDatabaseShare,
  IconDeviceMobileSearch,
  IconEyeFilled,
  IconFileImport,
  IconFileSearch,
  IconKey,
  IconLanguage,
  IconLayersSelected,
  IconLink,
  IconMail,
  IconMessageCircle,
  IconMessagePlus,
  IconPencil,
  IconPlus,
  IconQuestionMark,
  IconRefresh,
  IconRepeat,
  IconSearch,
  IconSparkles,
  IconStack,
  IconTablePlus,
  IconThumbUp,
  IconUserCheck,
  IconUserPlus,
  IconUserSearch,
  IconUsersGroup,
  IconUsersMinus,
  IconUserX,
  IconWorld,
  IconWorldSearch,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconGmaps } from "../../../../../components/Icons/IconGmaps";
import { IconLinkedinWithTip } from "../../../../../components/Icons/IconLinkedinWithTip"; // Assure-toi du bon chemin

export const types = (type, isOrigin, isEmail) => {
  let lang = useLanguage.getState().language;

  const iconStyle = { width: 24 };

  // Fonction utilitaire pour générer les icônes LinkedIn avec Tip
  const renderLinkedinIcon = (TipIcon) => (
    <IconLinkedinWithTip
      tipIcon={<TipIcon size={14} color="#4664e2" />}
      fill="#4664e2"
      size={24}
      style={iconStyle}
      tipStyles={{
        // background: "var(--mantine-color-primary-6)",
        top: -8, // Ajustez pour faire dépasser légèrement
        right: -8,
        padding: 1
      }}
    />
  );

  let all = {
    // --- STANDARD JOBS ---
    Creation: {
      icon: (
        <IconPlus
          style={{ width: isOrigin ? 16 : 18, opacity: isOrigin ? 0.75 : 1 }}
        />
      ),
      label: lang.contact_lists.jobs.types.Creation,
    },
    Copy: {
      icon: <IconCopy style={iconStyle} />,
      label: lang.contact_lists.jobs.types.Copy,
    },
    CopyTo: {
      icon: <IconCopy style={iconStyle} />,
      label: lang.contact_lists.jobs.types.CopyTo,
    },
    CopyToBlacklist: {
      icon: <IconUserX style={iconStyle} />,
      label: lang.contact_lists.jobs.types.CopyToBlacklist,
    },
    CopyToUnsubscribers: {
      icon: <IconUsersMinus style={iconStyle} />,
      label: lang.contact_lists.jobs.types.CopyToUnsubscribers,
    },
    Split: {
      icon: <IconArrowsSplit style={iconStyle} />,
      label: lang.contact_lists.jobs.types.Split,
    },
    Merge: {
      icon: <IconArrowMerge style={iconStyle} />,
      label: lang.contact_lists.jobs.types.Merge,
    },
    Import: {
      icon: <IconFileImport style={iconStyle} />,
      label: lang.contact_lists.jobs.types.Import,
    },
    ImportPreProcess: {
      icon: <IconFileImport style={iconStyle} />,
      label: lang.contact_lists.jobs.types.ImportPreProcess,
    },
    IceBreaker: {
      icon: <IconMessagePlus style={iconStyle} />,
      label: lang.contact_lists.jobs.types.IceBreaker,
    },
    Translate: {
      icon: <IconLanguage style={iconStyle} />,
      label: lang.contact_lists.jobs.types.Translate,
    },
    ContactListCopyContactListToPrm: {
      icon: <IconCopy style={iconStyle} />,
      label: lang.contact_lists.jobs.types.ContactListCopyContactListToPrm,
    },
    ZapierSendDataPrm: {
      icon: <IconBrandZapier style={iconStyle} />,
      label: lang.contact_lists.jobs.types.ZapierSendDataPrm,
    },
    ZapierSendDataStatistics: {
      icon: <IconBrandZapier style={iconStyle} />,
      label: lang.contact_lists.jobs.types.ZapierSendDataStatistics,
    },
    DatabaseExtractContacts: {
      icon: <IconDatabaseShare style={iconStyle} />,
      label: lang.contact_lists.jobs.types.DatabaseExtractContacts,
    },
    CronExecute: {
      icon: <IconAutomation style={iconStyle} />,
      label: lang.contact_lists.jobs.types.CronExecute,
    },
    DeleteContactsContactListFromBlacklist: {
      icon: <IconLayersSelected style={iconStyle} />,
      label:
        lang.contact_lists.jobs.types.DeleteContactsContactListFromBlacklist,
    },
    DeleteContactsContactListFromUnsubscribers: {
      icon: <IconLayersSelected style={iconStyle} />,
      label:
        lang.contact_lists.jobs.types
          .DeleteContactsContactListFromUnsubscribers,
    },
    DeleteContactsContactListFromContactList: {
      icon: <IconLayersSelected style={iconStyle} />,
      label:
        lang.contact_lists.jobs.types.DeleteContactsContactListFromContactList,
    },
    GoogleExtractMapsSearch: {
      icon: <IconGmaps style={iconStyle} />,
      label: lang.contact_lists.jobs.types.GoogleExtractMapsSearch,
    },
    PrmColumnEntryInstant: {
      icon: <IconTablePlus style={iconStyle} />,
      label: lang.contact_lists.jobs.types.PrmColumnEntryInstant,
    },

    // --- ENRICHMENT JOBS ---
    Enrich: {
      icon: <IconUserCheck style={iconStyle} />,
      label: lang.contact_lists.jobs.types.Enrich + (isEmail ? " Email" : ""),
    },
    EnrichExternalApi: {
      icon: <IconKey style={iconStyle} />,
      label: lang.contact_lists.jobs.types.EnrichExternalApi,
    },
    EnrichExternalApiPRM: {
      icon: <IconKey style={iconStyle} />,
      label: lang.contact_lists.jobs.types.EnrichExternalApi,
    },
    DatafieldAi: {
      icon: <IconSparkles style={iconStyle} />,
      label: lang.contact_lists.jobs.types.DatafieldAi,
    },
    DatafieldEnrich: {
      icon: <IconWorldSearch style={iconStyle} />,
      label: lang.contact_lists.jobs.types.DatafieldEnrich,
    },
    EnrichMobilePhone: {
      icon: <IconDeviceMobileSearch style={iconStyle} />,
      label: lang.contact_lists.jobs.types.EnrichMobilePhone,
    },
    EnrichBatch: {
      icon: <IconStack style={iconStyle} />,
      label: lang.contact_lists.jobs.types.EnrichBatch,
    },

    // --- LINKEDIN JOBS (avec Tip dynamique) ---
    ConvertLinkedinLinks: {
      icon: renderLinkedinIcon(IconLink),
      label: lang.contact_lists.jobs.types.ConvertLinkedinLinks,
    },
    EnrichLinkedinUrl: {
      icon: renderLinkedinIcon(IconUserSearch),
      label: lang.contact_lists.jobs.types.EnrichLinkedinUrl,
    },
    EnrichLinkedinData: {
      icon: renderLinkedinIcon(IconDatabase),
      label: lang.contact_lists.jobs.types.EnrichLinkedinData,
    },
    LinkedinExtractPublishersJobOffers: {
      icon: renderLinkedinIcon(IconBriefcase),
      label: lang.contact_lists.jobs.types.LinkedinExtractPublishersJobOffers,
    },
    LinkedinExtractPostLikers: {
      icon: renderLinkedinIcon(IconThumbUp),
      label: lang.contact_lists.jobs.types.LinkedinExtractPostLikers,
    },
    LinkedinExtractPostCommenters: {
      icon: renderLinkedinIcon(IconMessageCircle),
      label: lang.contact_lists.jobs.types.LinkedinExtractPostCommenters,
    },
    LinkedinExtractProfileViewers: {
      icon: renderLinkedinIcon(IconEyeFilled),
      label: lang.contact_lists.jobs.types.LinkedinExtractProfileViewers,
    },
    LinkedinExtractEventAttendees: {
      icon: renderLinkedinIcon(IconCalendarEvent),
      label: lang.contact_lists.jobs.types.LinkedinExtractEventAttendees,
    },
    LinkedinExtractCompanyViewers: {
      icon: renderLinkedinIcon(IconBuilding),
      label: lang.contact_lists.jobs.types.LinkedinExtractCompanyViewers,
    },
    LinkedinExtractGroupMembers: {
      icon: renderLinkedinIcon(IconUsersGroup),
      label: lang.contact_lists.jobs.types.LinkedinExtractGroupMembers,
    },
    LinkedinExtractPeopleCommentActivity: {
      icon: renderLinkedinIcon(IconMessageCircle),
      label: lang.contact_lists.jobs.types.LinkedinExtractPeopleCommentActivity,
    },
    LinkedinExtractPeoplePostActivity: {
      icon: renderLinkedinIcon(IconPencil),
      label: lang.contact_lists.jobs.types.LinkedinExtractPeoplePostActivity,
    },
    LinkedinExtractPeopleReactionActivity: {
      icon: renderLinkedinIcon(IconThumbUp),
      label:
        lang.contact_lists.jobs.types.LinkedinExtractPeopleReactionActivity,
    },
    LinkedinExtractPostReposters: {
      icon: renderLinkedinIcon(IconRepeat),
      label: lang.contact_lists.jobs.types.LinkedinExtractPostReposters,
    },
    LinkedinExtractSalesNavigatorPeoplesSearch: {
      icon: renderLinkedinIcon(IconCompass),
      label:
        lang.contact_lists.jobs.types
          .LinkedinExtractSalesNavigatorPeoplesSearch,
    },
    LinkedinExtractSalesNavigatorPeoplesSearchAlternative: {
      icon: renderLinkedinIcon(IconCompass),
      label:
        lang.contact_lists.jobs.types
          .LinkedinExtractSalesNavigatorPeoplesSearchAlternative,
    },
    LinkedinExtractSalesNavigatorCompaniesSearch: {
      icon: renderLinkedinIcon(IconBuilding),
      label:
        lang.contact_lists.jobs.types
          .LinkedinExtractSalesNavigatorCompaniesSearch,
    },
    LinkedinExtractSalesNavigatorCompaniesSearchAlternative: {
      icon: renderLinkedinIcon(IconBuilding),
      label:
        lang.contact_lists.jobs.types
          .LinkedinExtractSalesNavigatorCompaniesSearchAlternative,
    },
    LinkedinExtractPeoplesSearch: {
      icon: renderLinkedinIcon(IconSearch),
      label: lang.contact_lists.jobs.types.LinkedinExtractPeoplesSearch,
    },
    LinkedinExtractPeoplesSearchAlternative: {
      icon: renderLinkedinIcon(IconSearch),
      label:
        lang.contact_lists.jobs.types.LinkedinExtractPeoplesSearchAlternative,
    },
    LinkedinExtractConnections: {
      icon: renderLinkedinIcon(IconUserPlus),
      label: lang.contact_lists.jobs.types.LinkedinExtractConnections,
    },
    LinkedinExtractSearchContent: {
      icon: renderLinkedinIcon(IconFileSearch),
      label: lang.contact_lists.jobs.types.LinkedinExtractSearchContent,
    },

    // --- OVH JOBS ---
    OvhAddDomainStep1: {
      icon: <IconWorld style={iconStyle} />,
      label: lang.contact_lists.jobs.types.OvhAddDomainStep1,
    },
    OvhAddDomainStep2: {
      icon: <IconWorld style={iconStyle} />,
      label: lang.contact_lists.jobs.types.OvhAddDomainStep2,
    },
    OvhAddEmailStep1: {
      icon: <IconMail style={iconStyle} />,
      label: lang.contact_lists.jobs.types.OvhAddEmailStep1,
    },
    OvhAddEmailStep2: {
      icon: <IconMail style={iconStyle} />,
      label: lang.contact_lists.jobs.types.OvhAddEmailStep2,
    },
    OvhAddEmailStep3: {
      icon: <IconMail style={iconStyle} />,
      label: lang.contact_lists.jobs.types.OvhAddEmailStep3,
    },
    OvhAddEmailStep4: {
      icon: <IconMail style={iconStyle} />,
      label: lang.contact_lists.jobs.types.OvhAddEmailStep4,
    },
    OvhSyncAssets: {
      icon: <IconRefresh style={iconStyle} />,
      label: lang.contact_lists.jobs.types.OvhSyncAssets,
    },
    CopyProgrammationToContactList: {
      icon: <IconCopy style={iconStyle} />,
      label: lang.contact_lists.jobs.types.CopyProgrammationToContactList,
    },
  };

  return (
    all?.[type] || {
      icon: <IconQuestionMark style={iconStyle} />,
      label: "Unknown",
    }
  );
};
